import { LoadingButton } from "@mui/lab";
import { Button } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { ReactNode, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { TbPlus, TbRefresh } from "react-icons/tb";

import Panel from "@/layout/Panel";
import PanelTitle from "@/layout/PanelTitle";
import { useUpdateWetrackDataMutation } from "@/requests/user.mutations";
import { useUsersShowCreateDialog, useUsersTableActions } from "@/stores/use-users-table";

function UserPanel({ children, pagePermissions }: { children: ReactNode; pagePermissions: { edit: boolean } }) {
    const { t } = useTranslation();

    return (
        <Panel
            title={
                <PanelTitle title={t("users")}>
                    <div className="col-span-12 md:col-span-6 flex items-center justify-end gap-2">
                        <UpdateWetrackDataButton />
                        {pagePermissions.edit && <CreateUserButton />}
                    </div>
                </PanelTitle>
            }
        >
            {children}
        </Panel>
    );
}
function CreateUserButton() {
    const showCreateDialog = useUsersShowCreateDialog();
    const { updateShowCreateDialog } = useUsersTableActions();
    const { t } = useTranslation();
    const handleClick = useCallback(() => {
        updateShowCreateDialog(true);
    }, [updateShowCreateDialog]);
    return (
        <Button disabled={showCreateDialog} variant="contained" onClick={handleClick} startIcon={<TbPlus />}>
            {t("buttons.newUser")}
        </Button>
    );
}

function UpdateWetrackDataButton() {
    const { isPending, mutateAsync } = useUpdateWetrackDataMutation();
    const { t } = useTranslation();
    const handleClick = useCallback(async () => {
        try {
            if (isPending) return;
            const res = await mutateAsync();
            const message = res.message || "";
            if (res.ok) {
                enqueueSnackbar(message, {
                    variant: "success",
                });
            } else {
                enqueueSnackbar(message, {
                    variant: "error",
                });
            }
        } catch (error) {
            console.error("UpdateWetrackDataButton error:", error);
        }
    }, [mutateAsync, isPending]);
    return (
        <LoadingButton
            loading={isPending}
            type="submit"
            variant="outlined"
            color="primary"
            startIcon={<TbRefresh />}
            onClick={handleClick}
        >
            {t("buttons.updateWetrackData")}
        </LoadingButton>
    );
}
export default UserPanel;
